import React from 'react'

export const getComponentName = (Component) => Component.displayName || Component.name || 'Component'

const makeCustomPropTypesCheck = function (validate) {
  function checkType (isRequired, props, propName, componentName, location) {
    const prop = props[propName]
    if (prop === null || prop === undefined) {
      if (isRequired) {
        return new Error(`Prop ${propName} for component ${componentName} is required.`)
      }
      return null
    } else {
      return validate(props, propName, componentName, location)
    }
  }
  const chainedCheckType = checkType.bind(null, false)
  chainedCheckType.isRequired = checkType.bind(null, true)
  return chainedCheckType
}

const onlyElementOfType = function (type) {
  return makeCustomPropTypesCheck(
    function (props, propName, componentName) {
      const prop = props[propName]
      let error = null
      React.Children.forEach(prop, function (child) {
        if (child.type !== type) {
          error = new Error(`${componentName} children should be of type ${getComponentName(type)}, instead received ${getComponentName(child.type)}`)
        }
      })
      return error
    }
  )
}

const oneOfElementType = function (type) {
  return makeCustomPropTypesCheck(
    function (props, propName, componentName) {
      return type.reduce(function (acc, cur) {
        return acc || onlyElementOfType(cur)(props, propName, componentName)
      }, null)
    }
  )
}

const oneOfObjectKeys = function (obj) {
  return makeCustomPropTypesCheck(
    function (props, propName, componentName) {
      const prop = props[propName]
      if (prop === undefined || prop === null) return null
      let error = new Error(`Invalid props for component ${componentName}: ${propName} should be one of ${Object.keys(obj)}, instead received ${prop}`)
      Object.keys(obj).forEach((key) => {
        if (key === prop) error = null
      })
      return error
    }
  )
}

const validateBasedOnOtherProps = function (getProps, validator) {
  return makeCustomPropTypesCheck(
    function (props, propName, componentName) {
      const prop = getProps(props)
      return validator(prop, componentName)
    }
  )
}

export const customPropTypes = {
  onlyElementOfType,
  oneOfElementType,
  oneOfObjectKeys,
  validateBasedOnOtherProps
}
